/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation, useReactiveVar } from '@apollo/client';

import { CREATE_CLASSIFY_AUDIT_LOGS_FOR_FRY7Q } from 'Apollo/Mutations/Rules/Fry7qResults';
import { tenantIdVar } from 'Apollo/config';
import ClassifyResultModal from '../../common/ClassifyResultModal';

const ClassifyResult = ({
    setShowClassifyResult, refetch, refetchTestData,
}) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [comment, setComment] = useState('');
    const [radio, setRadio] = useState('MARK_AS_REVIEW_REQUIRED');
    const [showLoader, setShowLoader] = useState(false);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo mutation to update the comment */
    const [createClassifyAuditLogForFRY7Q] = useMutation(
        CREATE_CLASSIFY_AUDIT_LOGS_FOR_FRY7Q,
        {
            variables: {
                input: {
                    comment,
                    batchId: Number(batchId),
                    eventName: radio,
                    ruleId: Number(ruleId),
                    tenantId: Number(tenantId),
                },
            },
        },
    );

    /* Calls createClassifyAuditLogForFRY7Q(), refetches the failed test and audit logs data  */
    const onClickFRY7QClassify = async () => {
        setShowLoader(true);
        await createClassifyAuditLogForFRY7Q();
        setComment('');
        setShowLoader(false);
        refetch();
        refetchTestData();
        setShowClassifyResult(false);
    };

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <ClassifyResultModal
            onClickClassify={onClickFRY7QClassify}
            showLoader={showLoader}
            comment={comment}
            setComment={setComment}
            radio={radio}
            setRadio={setRadio}
            setShowClassifyResult={setShowClassifyResult}
        />
    );
};

export default ClassifyResult;
